<template>
  <div class="selfStudyINtroPage">
    <div class="selfStudy">
      <Navbar
        :title="courseData.name"
        :backNative="isApp"
        v-if="showTitle"
        style="position: absolute; top: 0; z-index: 9999"
        class="topNav"
      />

      <div class="bg">
        <img
          class="back"
          @click="toBack"
          :style="{ top: statusHeight + 'px' }"
          src="../../assets/images/backIcon.png"
          alt=""
        />
        <div class="courseType">
          <div class="typeInfo" ref="scrollOne">
            <div class="typeTitle">{{ courseData.name }}</div>
            <div class="person_num">
              <span>{{ courseData.title }}</span>
            </div>
          </div>

          <div class="sections">
            {{ courseData.courseDetailNum }}<span>节课</span>
          </div>
        </div>
      </div>

      <div class="content">
        <van-tabs
          @click="onClick"
          swipeable
          v-model="initTab"
          animated
          color="#FC541E"
          line-height="4px"
          line-width="32px"
        >
          <van-tab
            title="课程简介"
            name="课程简介"
            title-style="font-size:15px;font-weight:600;margin-left:50px"
          >
            <div v-html="courseData.info" class="richText"></div>
          </van-tab>
          <van-tab
            title="课程目录"
            name="课程目录"
            title-style="font-size:15px;font-weight:600;margin-right:50px"
          >
            <div class="course">
              <div
                class="courseCard"
                v-for="(item, index) in detailList"
                @click="toCourseDetail(item.id)"
                :key="index"
              >
                <div class="classes">
                  <img src="../../assets/images/playIcon.png" alt="" />
                </div>
                <div class="sectionName">
                  <div class="classesName">{{ item.title }}</div>
                  <div class="time">{{ item.duration }}</div>
                </div>

                <div
                  class="lastLearn"
                  ref="lastLearn"
                  id="last"
                  v-if="item.id == sectionId"
                >
                  上次学习
                </div>

                <div
                  class="workStatus"
                  v-if="item.status != 0 && item.status != null"
                  :class="item.status == 2 ? 'passwork' : 'nopass'"
                >
                  <img
                    :src="
                      item.status == 1
                        ? require('../../assets/images/status-d.png')
                        : item.status == 2
                        ? require('../../assets/images/status-true.png')
                        : require('../../assets/images/status-x.png')
                    "
                    alt=""
                  />
                  <div>
                    {{
                      item.status == 1
                        ? "待审核"
                        : item.status == 2
                        ? "已完成"
                        : "未通过"
                    }}
                  </div>
                </div>
                <div class="lockIcon" v-if="!isBuy">
                  <img src="../../assets/images/lock.png" alt="" />
                </div>
                <img
                  class="listBg"
                  src="../../assets/images/courseListBg.png"
                  alt=""
                />
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <div class="buyBt" v-if="!showPosition && !isBuy">
      <div class="nowprice"><span>￥</span>{{ courseData.price }}</div>

      <div class="agoprice">￥{{ courseData.cost }}</div>

      <div class="tobuy" @click="toBuyCourse">立即购买</div>
    </div>

    <!-- <div class="postionIcon" @click="toLastLearn" v-if="showPosition||isBuy">
        <img src="../../assets/images/position.png" alt="">
  </div> -->
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
import { Toast } from "vant";
export default {
  data() {
    return {
      showTitle: false,
      showPosition: false,
      courseData: {}, //课程数据
      detailList: [], //目录列表
      isBuy: false, //课程是否购买
      sectionId: "", //上次学习课节id
      initTab: "课程简介",
      tabs: [
        // {
        //   title: "课程简介"
        // },
        // {
        //   title: "课程目录"
        // }
      ],

      showTips: false, //展示弹框
      active: 0,
      isApp: false,
    };
  },
  components: {
    Navbar,
  },
  created() {
    // window.RefreshSpeedCourse = () => {
    //   //  Toast(1)
    //   this.getLastStudy();
    //   this.getCourseDetailList();
    //   this.getCourse();
    //   this.checkIsBuy();
    // };
  },
  mounted() {
    // let that = this;
    // window.addEventListener(
    //   "popstate",
    //   (e) => {
    //     that.$store.commit("Set_refresh", true);
    //   },
    //   false
    // );
    // window.addEventListener("scroll", this.handleScroll);
    // this.getLastStudy();
    // this.getCourseDetailList();
    // this.getCourse();
    // this.checkIsBuy();
    //
  },
  activated() {
    window.addEventListener("scroll", this.handleScroll);

    this.getLastStudy();
    this.getCourseDetailList();
    this.getCourse();
    this.checkIsBuy();
  },
  computed: {
    statusHeight() {
      return this.$store.state.statusHeight;
    },
  },
  methods: {
    initPage() {
      window.RefreshSpeedCourse = () => {
        //  Toast(1)
        this.getLastStudy();
        this.getCourseDetailList();
        this.getCourse();
        this.checkIsBuy();
      };
      let that = this;
      window.addEventListener(
        "popstate",
        (e) => {
          that.$store.commit("Set_refresh", true);
        },
        false
      );

      window.addEventListener("scroll", this.handleScroll);

      this.getLastStudy();
      this.getCourseDetailList();
      this.getCourse();
      this.checkIsBuy();
    },
    getLastStudy() {
      //获取上次学习位置
      let query = this.$route.query;

      http
        .getLastStudy({
          courseId: query.id,
          type: 3,
        })
        .then((res) => {
          this.sectionId = res.courseDetailId;

          setTimeout(() => {
            if (this.detailList.length > 8) {
              document
                .getElementById("last")
                .scrollIntoView({ block: "center", behavior: "smooth" });
            }
          }, 500);
          //  this.getCourseDetailList()
        });
    },

    getCourseDetailList() {
      //获取课程目录
      let query = this.$route.query;
      if (query.isApp) {
        this.isApp = query.isApp;
      }
      http
        .getCourseDetailList({
          courseId: query.id,
        })
        .then((res) => {
          this.detailList = res;
        });
    },
    getCourse() {
      //获取课程简介
      let query = this.$route.query;
      http
        .getCourse({
          type: query.type,
          courseId: query.id,
        })
        .then((res) => {
          this.courseData = res;
          console.log(res);
        });
    },
    //判断课程是否购买
    checkIsBuy() {
      let query = this.$route.query;
      http.checkIsBuy({ dataId: query.id, type: 3 }).then((res) => {
        this.isBuy = res;
        this.initTab = res ? "课程目录" : "课程简介";
      });
    },
    //页面滚动
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let oneHeight = this.$refs.scrollOne.offsetHeight;
      //
      console.log(scrollTop, oneHeight);

      if (scrollTop > oneHeight) {
        //这是滑动到scrollTwo的距离要做的操作
        this.showTitle = true;
      } else {
        this.showTitle = false;
      }
    },

    toLastLearn() {
      //定位到已学习的位置
      document
        .getElementById("last")
        .scrollIntoView({ block: "center", behavior: "smooth" });
    },

    onClick(name, title) {
      //点击tabs
      if (title == "课程目录") {
        this.showPosition = true;
      } else {
        this.showPosition = false;
      }
    },
    toBack() {
      //返回上一页

      this.$store.commit("Set_refresh", true);
      if (this.isApp) {
        http.guitarAppListener("backToNative", {});
      } else {
        this.$router.go(-1);
      //   this.$router.push({
      //   path: "/SpeedStudyList",
      //   query: { type: 3 },
      // }).then(res=>window.PushToken(this.$store.state.token));
      }
    },
    toCourseDetail(id) {
      if (this.isBuy) {
        //  Toast(id)
        http.guitarAppListener("toCourseDetail", { id });
      } else {
        Toast("请先购买！");
      }
    },

    toBuyCourse() {
      //去支付
      let query = this.$route.query;
      http.guitarAppListener("toBuyCourse", { type: 3, dataId: query.id });

      //   if(http.deviceType()=='Android'){
      // JSBridge.toBuyCourse();
      // }else if(http.deviceType()=='IOS'){
      //  window.webkit.messageHandlers.toBuyCourse.postMessage(null);
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.selfStudyINtroPage {
  position: relative;
  min-height: 100vh;
}
.postionIcon {
  width: 44px;
  height: 32px;
  background: linear-gradient(135deg, #363346, #222030);
  border-radius: 16px 0px 0px 16px;
  position: fixed;
  bottom: 32px;
  right: 0;
  z-index: 999;
  padding: 6px 8px;
  box-sizing: border-box;
  img {
    width: 20px;
    height: 20px;
  }
}
.richText {
  padding-bottom: 60px;
  /deep/ img {
    max-width: 99%;
  }
}
.buyBt {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  background: #fff;
  z-index: 9999;
  display: flex;
  padding: 0 16px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  .nowprice {
    font-weight: 700;
    font-size: 24px;
    color: #fc541e;
    span {
      font-weight: 700;
      display: inline-block;
      font-size: 15px;
    }
  }
  .agoprice {
    width: 32px;
    height: 15px;
    background: url("../../assets/images/pop.png");
    background-size: 100% 100%;
    color: #fc541e;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    // text-align: center;
    // line-height: 15px;
    text-decoration: line-through;
    margin-left: 4px;
    margin-right: 42px;
  }
  .tobuy {
    width: 220px;
    height: 40px;
    background: linear-gradient(135deg, #ff7337 0%, #fc541e);
    border-radius: 20px;
    box-shadow: 0px -4px 10px 0px rgba(34, 32, 48, 0.04);
    color: #ffffff;
    font-size: 15px;
    line-height: 40px;
    text-align: center;
    flex: 1;
  }
}
.selfStudy {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;

  .bg {
    width: 100%;
    height: 174px;
    background: url("../../assets/images/learnBg.png");
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .back {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 14px;
      left: 16px;
    }
    .courseType {
      width: calc(100% - 32px);
      margin: 0 auto;
      margin-top: 76px;
      display: flex;
      justify-content: space-between;
      align-items: "center";
      .typeInfo {
        .typeTitle {
          font-size: 24px;
          // width:calc(100% - 60px);
          font-weight: bold;
          color: #fff;
        }
        .person_num {
          display: flex;
          margin-top: 2px;

          span {
            color: #c9c7ca;
            font-size: 13px;
            display: inline-block;
            margin-left: 4px;
          }
        }
      }
      .sections {
        font-size: 24px;
        color: #ffffff;
        display: flex;
        align-items: center;

        font-weight: 600;
        span {
          font-weight: 400;
          color: rgba(255, 255, 255, 0.45);
          font-size: 13px;
          display: inline-block;
          margin-left: 4px;
        }
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -18px;
    position: relative;
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;

    .van-tabs {
      /deep/ .van-tabs__line {
        bottom: 19px !important;
      }
    }

    .course {
      margin-top: 10px;
      .courseCard {
        width: 100%;
        margin: 0 auto;
        height: 77px;
        border-radius: 6px 6px 6px 6px;
        background: #f6f6f6;
        position: relative;
        overflow: hidden;
        padding: 16px;
        box-sizing: border-box;
        margin-bottom: 8px;
        display: flex;
        .listBg {
          width: 114px;
          height: 59px;
          object-fit: contain;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 0;
        }

        .classes {
          margin-top: 2px;
          img {
            width: 16px;
            height: 16px;
          }
        }
        .sectionName {
          flex: 1;
          margin-left: 8px;
          .classesName {
            font-size: 15px;
            color: #222030;
          }
          .time {
            font-size: 11px;
            color: rgba(34, 32, 48, 0.45);
            margin-top: 7px;
          }
        }

        .lastLearn {
          width: 60px;
          height: 23px;
          border: 1px solid #222030;
          border-radius: 4px;
          color: #222030;
          font-size: 10px;
          text-align: center;
          line-height: 23px;
          position: relative;
          z-index: 2;
          margin-top: 10px;
        }
        .workStatus {
          margin-left: 2px;
          position: relative;
          margin-top: 10px;
          z-index: 2;
          width: 62px;
          height: 23px;
          border-radius: 4px;
          background: #fc541e;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 10px;
          img {
            width: 12px;
            height: 12px;
            margin-right: 4px;
          }
        }
        .passwork {
          background: #222030;
        }
        .nopass {
          background: #6f6e78;
        }
        .lockIcon {
          position: relative;
          z-index: 2;
          margin-top: 12px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>

